import React, { ReactElement } from 'react';
import styles from './WhiteSectionContainer.module.scss';

type Props = {
    children: ReactElement | ReactElement[];
};

export const SectionContainer = ({ children }: Props): ReactElement => {
    return <div className={styles.container}>{children}</div>;
};
const WhiteSectionContainer = ({ children }: Props): ReactElement => {
    return <div className={styles.whiteContainer}>{children}</div>;
};

export default WhiteSectionContainer;
